export default "__VITE_ASSET__DRG0gViK__"